import { render, staticRenderFns } from "./duzenle.vue?vue&type=template&id=12ac757c&lang=html&"
import script from "./duzenle.vue?vue&type=script&lang=js&"
export * from "./duzenle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports